
import QuoteTweet  from "./QuoteTweet";
import QuoteLine from "./QuoteLine";
import QuoteFacebook  from "./QuoteFacebook";
import { defineComponent, reactive, onMounted, onUnmounted } from "vue";

interface State {
  x: number,
  y: number,
  view: boolean,
  text: string
}

export default defineComponent({
  name: "QuoteToolTip",
  components: {
    QuoteTweet, QuoteFacebook, QuoteLine
  },
  setup() {
    const state = reactive<State>({
      x: 0,
      y: 0,
      view: false,
      text: ""
    });
    onMounted(() => {
      document.addEventListener("mouseup", selectEnd);
    });
    onUnmounted(() => {
      document.removeEventListener("mouseup", selectEnd);
    });
    const selectEnd = () => {

      const selection = window.getSelection();
      if(selection.type !== "Range") {
        state.view = false;
        return ;
      }
      const range = selection.getRangeAt(0);

      const main = document.querySelector(".main_text");
      const summary = document.querySelector(".pressrelease_detail_text");
      const title = document.querySelector(".articleHd");
      const node = range.commonAncestorContainer;

      if(!title.contains(node) && !summary.contains(node) && !main.contains(node)) {
        state.view = false;
        return;
      }
      // safariの場合、選択した範囲が折りたたまれ、
      // getBoundingClientRectの値が変わってしまうため先にposに代入しておく
      const pos = range.getBoundingClientRect();

      // ブラウザがsafariの場合は選択範囲の終了位置で折りたたむ
      // この処理をしない場合、mouseupしたときに選択した範囲の反転が外れる場合があるため
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("safari") !== -1 && userAgent.indexOf("chrome") === -1) {
        range.collapse(false);
      }

      // safariで範囲指定すると吹き出し部の範囲選択が欠けるのでspanタグをつける
      const anchor = document.createElement("span");
      range.insertNode(anchor);

      // ツールチップ表示位置の調整
      state.view = true;
      if (pos.height >= 54) {
        // 選択範囲が2行以上のときは1番上の行全体の中央にポジションを合わせる
        state.x = pos.x + 290;
      } else {
        // 選択範囲が1行のときは選択範囲の中央にポジションを合わせる
        state.x = pos.x - 60 + pos.width / 2;
      }
      state.y = pos.y + window.scrollY - 52;
      state.text = selection.toString();
    };
    return {
      state
    };
  }
});
